/** First-hover wait, avoiding popups during incidental pointer movement. */
export const DEFAULT_TOOLTIP_DELAY_MS = 400;
/** After one tooltip, later ones in this window open immediately. */
export const DEFAULT_TOOLTIP_SKIP_DELAY_MS = 300;
